import axios from 'axios'
import { generateResponse, generateErrorResponse } from './common'

const API_END_POINT = process.env.API_END_POINT
const CATEGORIES = API_END_POINT + '/categories/'

export default {
  API_END_POINT: API_END_POINT,
  getById (type, id, params = {}) {
    return axios({
      url: CATEGORIES + type + '/' + id,
      method: 'get',
      params: params
    }).then(generateResponse, generateErrorResponse)
  },
  get (type = 'company', params = { page: 1 }) {
    return axios({
      url: CATEGORIES + type,
      method: 'get',
      params: params
    }).then(generateResponse, generateErrorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api/categories.js